export default __webpack_public_path__ + "static/media/i240vk.f8edf3c2.webp";